import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from "react-router-dom"
//MUI
import { create } from 'jss';
import rtl from 'jss-rtl';
import { MuiThemeProvider, createMuiTheme, withStyles } from '@material-ui/core/styles';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
//Mine
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const THEME = createMuiTheme({
    typography: {
        fontFamily: `"Dana-FaNum", "Tahoma", Arial`,
    },
    direction: 'rtl',
});

const styles = theme => ({
    container: {
        [theme.breakpoints.up("lg")]: {
            width: '1280px'
        }
    },
    base: {
        flexGrow: 1,
        marginTop: '30px',
        marginBottom: '50px'
    },
});

class BoxedLayout extends React.Component {
    render() {
        const { classes } = this.props;
        const { children, breadcrumbsItems, lang, title, description, keywords, metas } = this.props
        if (!localStorage.getItem("lang"))
            localStorage.setItem('lang', this.props.lang)

        return (
            <>
                <title>{title}</title>
                {metas &&
                    Object.entries(metas).map(([key, value]) => {
                        return <meta name={key.toString()} content={value.toString()} />;
                    })}
                <Header lang={lang} />
                <main className="homePage">
                    <MuiThemeProvider theme={THEME}>
                        <StylesProvider jss={jss}>

                            <Grid container justify="center" alignItems="top" spacing={1}>
                                <Grid container justify="right" alignItems="" spacing={1}>
                                    <Paper elevation={0}>
                                        <Box elevation={0} boxShadow={0} p={1} m={1} className="breadcrumbs-container">
                                            <Breadcrumbs className={classes.breadcrumbs + ' breadcrumbs'} separator="›" aria-label="breadcrumb">
                                                {breadcrumbsItems.map((item, i) => (
                                                    (i + 1 !== breadcrumbsItems.length) ? (
                                                        <RouterLink to={item.to} color="inherit">{item.title}</RouterLink>
                                                    ) : (
                                                        <Typography color="textPrimary">{item.title}</Typography>
                                                    )
                                                ))}
                                            </Breadcrumbs>
                                        </Box>
                                    </Paper>
                                </Grid>
                            </Grid>

                            <Grid container justify="center" className={classes.base} alignItems="top" spacing={1}>
                                <Grid container className={classes.container} justify="center" alignItems="" spacing={1}>
                                    <Grid item xs={12}>
                                        <Box elevation={0} p={1} m={1}>
                                            <Grid container>
                                                {children}
                                            </Grid>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </StylesProvider>
                    </MuiThemeProvider>
                </main>
                <Footer lang={lang} />
            </>
        )
    }

}

BoxedLayout.propTypes = {
    children: PropTypes.instanceOf(Object),
    breadcrumbsItems: PropTypes.array,
    lang: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
}

BoxedLayout.defaultProps = {
    children: <></>,
    breadcrumbsItems: [{
        title: 'صفحه اصلی',
        to: "/"
    }],
    lang: 'fa',
    title: 'آجیل حسن پور',
    description: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
    keywords: 'خرید اینترنتی آجیل,خشکبار',
}

export default withStyles(styles)(BoxedLayout);